const createButtonTokens = ({
  colors,
  colorsBrand,
  radii,
  borders,
  space,
}) => ({
  colors: {
    default: {
      color: colorsBrand[1],
      borderColor: colorsBrand[1],
      hover: {
        color: colorsBrand[2],
        borderColor: colorsBrand[2],
        bgColor: 'transparent',
      },
      active: {
        color: colorsBrand[2],
        borderColor: colorsBrand[2],
      },
      disabled: {
        bgColor: colorsBrand[1],
        color: colorsBrand[1],
        borderColor: colorsBrand[1],
      },
    },
    highlight: {
      bgColor: colorsBrand[1],
      borderColor: colorsBrand[1],
      hover: {
        bgColor: colorsBrand[2],
        borderColor: colorsBrand[2],
      },
      active: {
        color: colorsBrand[2],
        borderColor: colorsBrand[2],
      },
      disabled: {
        bgColor: colorsBrand[1],
        color: colors.white,
        borderColor: colorsBrand[1],
      },
    },
    secondary: {
      color: colorsBrand[1],
      borderColor: colors.neutrals[5],
      backgroundGradientFrom: colors.white,
      backgroundGradientTo: colors.neutrals[8],
      hover: {
        bgColor: colors.white,
        backgroundGradientFrom: colors.white,
        backgroundGradientTo: colors.white,
      },
      active: {
        bg: colors.white,
      },
      disabled: {
        bgColor: colorsBrand[1],
        color: colors.neutrals[3],
        borderColor: colors.neutrals[6],
      },
    },
    text: {
      color: colorsBrand[1],
      disabled: {
        color: colorsBrand[1],
      },
      hover: {
        color: colorsBrand[2],
        bgColor: colorsBrand[0],
      },
    },
  },
  borders: {
    default: borders[2],
  },
  space: {
    medium: {
      px: space[4],
      py: space[3],
    },
    large: {
      px: space[5],
      py: space[3],
    },
  },
  radii: [radii[0], radii.small],
  transition: 'none',
  transform: 'none',
  opacity: '.4',
});

export default createButtonTokens;
